// 账户相关
export const VALIDATE_INVITE_CODE = 'ValidateInviteCode';
export const GET_SELF_ACCOUNT = 'GetSelfAccount';
export const APPLY_ACCOUNT = 'ApplyAccount';
export const APPLY_DELETE_ACCOUNT = 'ApplyDeleteAccount';
export const CANCEL_DELETE_ACCOUNT = 'CancelDeleteAccount';
export const CANCEL_ACCOUNT_APPLICATION = 'CancelAccountApplication';
export const BIND_BANK_ACCOUNT = 'BindBankAccount';
export const GET_BILLS = 'GetBills';
export const GET_BILL_DETAILS = 'GetBillDetails';
export const GET_USER_INFO = 'GetUserInfo';
export const GET_INVITE_INFO = 'GetInviteInfo';

// 任务相关
export const GET_AVAILABLE_TASKS = 'GetAvailableTasks';
export const GET_CREATOR_TASKS = 'GetCreatorTasks';
export const CLAIM_TASK = 'ClaimTask';
export const GET_TASK = 'GetTask';
export const ABANDON_TASK = 'AbandonTask';
export const BIND_MOMENTS_PICTURE = 'SubmitPyqPicture';
export const GET_MOMENT_PIC_URL = 'GetPyqPictureURL';

// 视频号相关
export const BIND_CHANNEL_INFO = 'BindFinderAccount';

// 短信验证码相关
export const SEND_SMS_VERIFICATION_CODE = 'SendSmsVerificationCode';
export const VERIFY_SMS_CODE = 'Verification';

// COS相关
export const GET_COS_CREDENTIALS = 'GetPyqPictureUploadCredential';

// 课堂相关
export const GET_COURSE = 'GetCourses';

// 站内信相关
export const GET_UNREAD_MSG_COUNT = 'GetUnreadMsgCount';
export const GET_INBOX_MSGS = 'GetInboxMsgs';
